export const prepareRegionsOkedsData = ([regions, activities], data) => {
  const projects_by_activity = [];
  const projects_by_region = [];

  data.projects_by_activity.forEach((activity) => {
    activity.phases.forEach((phase) => {
      projects_by_activity.push({
        activity: activities[activity.id],
        phase: phase.phase_id,
        value: phase.count,
      });
    });
  });

  data.projects_by_region.forEach((region) => {
    region.phases.forEach((phase) => {
      projects_by_region.push({
        region: regions[region.id],
        phase: phase.phase_id,
        value: phase.count,
      });
    });
  });

  return {
    regions_kpi: data.regions_kpi.map((item, index) => {
      return {
        num: index + 1,
        region: regions[item.id],
        id: item.id,
        kpi_1: item.kpi_1,
        kpi_2: item.kpi_2,
      };
    }),
    activity_kpi: data.activity_kpi.map((item, index) => {
      return {
        num: index + 1,
        activity: activities[item.activity_id],
        id: item.activity_id,
        kpi_1: item.kpi_1,
        kpi_2: item.kpi_2,
      };
    }),
    quarter_kpi: [
      ...data.quarter_kpi.map((item) => {
        return {
          quarter: `${item.quarter}кв ${item.year}`,
          type: 'kpi_1',
          value: item.kpi_1,
        };
      }),
      ...data.quarter_kpi.map((item) => {
        return {
          quarter: `${item.quarter}кв ${item.year}`,
          type: 'kpi_2',
          value: item.kpi_2,
        };
      }),
    ],
    projects_by_activity,
    projects_by_region,
  };
};

export const prepareRegionData = ([districts, activities], data) => {
  const projects_by_activity = [];
  const projects_by_district = [];

  data.projects_by_activity.forEach((activity) => {
    activity.phases.forEach((phase) => {
      projects_by_activity.push({
        activity: activities[activity.id],
        phase: phase.phase_id,
        value: phase.count,
      });
    });
  });

  data.projects_by_district.forEach((region) => {
    region.phases.forEach((phase) => {
      projects_by_district.push({
        district: districts[region.id],
        phase: phase.phase_id,
        value: phase.count,
      });
    });
  });

  return {
    district_kpi: data.district_kpi.map((item, index) => {
      return {
        num: index + 1,
        region: districts[item.id],
        id: item.id,
        kpi_1: item.kpi_1,
        kpi_2: item.kpi_2,
      };
    }),
    activity_kpi: data.activity_kpi.map((item, index) => {
      return {
        num: index + 1,
        activity: activities[item.activity_id],
        id: item.activity_id,
        kpi_1: item.kpi_1,
        kpi_2: item.kpi_2,
      };
    }),
    quarter_kpi: [
      ...data.quarter_kpi.map((item) => {
        return {
          quarter: `${item.quarter}кв ${item.year}`,
          type: 'kpi_1',
          value: item.kpi_1,
        };
      }),
      ...data.quarter_kpi.map((item) => {
        return {
          quarter: `${item.quarter}кв ${item.year}`,
          type: 'kpi_2',
          value: item.kpi_2,
        };
      }),
    ],
    projects_by_activity,
    projects_by_district,
  };
};

export const prepareOkedsData = (regions, data) => {
  const projects_by_region = [];
  data.projects_by_region.forEach((region) => {
    region.phases.forEach((phase) => {
      projects_by_region.push({
        region: regions[region.id],
        phase: phase.phase_id,
        value: phase.count,
      });
    });
  });

  return {
    regions_kpi: data.regions_kpi.map((item, index) => {
      return {
        num: index + 1,
        region: regions[item.id],
        id: item.id,
        kpi_1: item.kpi_1,
        kpi_2: item.kpi_2,
      };
    }),
    quarter_kpi: [
      ...data.quarter_kpi.map((item) => {
        return {
          quarter: `${item.quarter}кв ${item.year}`,
          type: 'kpi_1',
          value: item.kpi_1,
        };
      }),
      ...data.quarter_kpi.map((item) => {
        return {
          quarter: `${item.quarter}кв ${item.year}`,
          type: 'kpi_2',
          value: item.kpi_2,
        };
      }),
    ],
    projects_by_region,
  };
};

const phaseKeysDict = {
  1: 'investment_period',
  2: 'post_investment_period',
};

export const prepareSubOkedsData = ([activities, phases], data) => {
  return {
    quarter_kpi: [
      ...data.quarter_kpi.map((item) => {
        return {
          quarter: `${item.quarter}кв ${item.year}`,
          type: 'kpi_1',
          value: item.kpi_1,
        };
      }),
      ...data.quarter_kpi.map((item) => {
        return {
          quarter: `${item.quarter}кв ${item.year}`,
          type: 'kpi_2',
          value: item.kpi_2,
        };
      }),
    ],
    projects: data.projects.map((item) => {
      return {
        ...item,
        activity: activities[item.activity_id],
        phase: phases[item.phase_id],
      };
    }),
    effects: {
      project_count: data.effects.project_count
        ? [
            Object.fromEntries(
              data.effects.project_count.map((item) => [
                phaseKeysDict[item.phase_id],
                item.value,
              ])
            ),
          ]
        : [],
      investment_sum: data.effects.investment_sum
        ? [
            Object.fromEntries(
              data.effects.investment_sum.map((item) => [
                phaseKeysDict[item.phase_id],
                item.value,
              ])
            ),
          ]
        : [],
      job_effect: data.effects.job_effect
        ? [
            Object.fromEntries(
              data.effects.job_effect.map((item) => [
                phaseKeysDict[item.phase_id],
                item.value,
              ])
            ),
          ]
        : [],
      tax_effect: data.effects.tax_effect
        ? [
            Object.fromEntries(
              data.effects.tax_effect.map((item) => [
                phaseKeysDict[item.phase_id],
                item.value,
              ])
            ),
          ]
        : [],
    },
  };
};

export const prepareDistrictData = ([activities, phases], data) => {
  return {
    quarter_kpi: [
      ...data.quarter_kpi.map((item) => {
        return {
          quarter: `${item.quarter}кв ${item.year}`,
          type: 'kpi_1',
          value: item.kpi_1,
        };
      }),
      ...data.quarter_kpi.map((item) => {
        return {
          quarter: `${item.quarter}кв ${item.year}`,
          type: 'kpi_2',
          value: item.kpi_2,
        };
      }),
    ],
    projects: data.projects.map((item) => {
      return {
        ...item,
        activity: activities[item.activity_id],
        phase: phases[item.phase_id],
      };
    }),
    effects: {
      project_count: data.effects.project_count
        ? [
            Object.fromEntries(
              data.effects.project_count.map((item) => [
                phaseKeysDict[item.phase_id],
                item.value,
              ])
            ),
          ]
        : [],
      investment_sum: data.effects.investment_sum
        ? [
            Object.fromEntries(
              data.effects.investment_sum.map((item) => [
                phaseKeysDict[item.phase_id],
                item.value,
              ])
            ),
          ]
        : [],
      job_effect: data.effects.job_effect
        ? [
            Object.fromEntries(
              data.effects.job_effect.map((item) => [
                phaseKeysDict[item.phase_id],
                item.value,
              ])
            ),
          ]
        : [],
      tax_effect: data.effects.tax_effect
        ? [
            Object.fromEntries(
              data.effects.tax_effect.map((item) => [
                phaseKeysDict[item.phase_id],
                item.value,
              ])
            ),
          ]
        : [],
    },
  };
};

export function prepareFilters(source) {
  return Object.fromEntries(
    Object.entries(source)
      .filter(
        ([key, value]) =>
          !(
            value === null ||
            (Array.isArray(value) && value?.length === 0) ||
            value === 0
          )
      )
      .map(([key, value]) => [key, value])
  );
}
